import React, { useState,useEffect } from "react";
import Navbar from "./Navbar";
import ReactPaginate from "react-paginate";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
function EmployeesNeededRequests() {
    const ID = Cookies.get("log_id");
    const [requests,setRequests] = useState([]);
    function FetchNeededRequests() {
        axios.get(`${url.path}/fetch_needed_employees_requests/`)
        .then((res) =>{
            if(res.data.status){
                var emp = res.data.requests;
                setRequests([])
                emp.map((e)=>{
                    setRequests((prevState)=>[
                        ...prevState, e
                    ])
                })
            }
            }).catch((err) => {
                console.log("ERROR", err);
              });
    }
    useEffect(() =>{
        FetchNeededRequests();
    }, [])
    const itemsPerPage = 3;
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(0);

    const filteredData = requests.filter((item) =>
      item.Role_Of_Employees.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const offset = currentPage * itemsPerPage;
    const currentItems = filteredData.slice(offset, offset + itemsPerPage);
    const pageCount = Math.ceil(filteredData.length / itemsPerPage);

    const handlePageClick = ({ selected }) => {
      setCurrentPage(selected);
    };
    function searchTable(){
      var rows = document.querySelectorAll('#productstable tbody tr');
      var val = document.getElementById('search').value.trim().replace(/ +/g, ' ').toLowerCase();
      rows.forEach(function(row) {
        var text = row.textContent.replace(/\s+/g, ' ').toLowerCase();
        row.style.display = text.includes(val) ? '' : 'none';
      });
    }
    return(
        <>
        <Navbar />
        <center>
            <h3 style={{fontSize:'20px',position:'relative',top:'10px'}}>Needed Requests</h3>
            </center>
            <div className="search-container">
                <input
                type="text"
                placeholder="Search..."
                onKeyUp={searchTable}
                className="search-input"
                id="search"
                />
            </div>
        <div className="table-container">
            
      <table className="responsive-table" id="productstable">
        <thead>
          <tr>
            <th>Sl.No</th>
            <th>Company Name</th>
            <th>Role</th>
            <th>Department</th>
            <th>Count</th>
            <th>From</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {requests.map((i,index) => (
            <tr key={i.id}>
              <td>{index+1}</td>
              <td>{i.Requesting_Company_Name}</td>
              <td>{i.Role_Of_Employees}</td>
              <td>{i.Department}</td>
              <td>{i.Needed_Employees_Count}</td>
              <td>{i.From}</td>
              <td>{i.End}</td>  
            </tr>
          ))}
        </tbody>
      </table>
      {filteredData.length > itemsPerPage && (
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}
    </div>
        </>
    );
}
export default EmployeesNeededRequests;